import(/* webpackPreload: true */ './application').catch((e) => {
  // eslint-disable-next-line no-console
  console.error('Failed loading application!', e);
});
